
import { defineComponent, ref } from "vue";
import { Modal } from "bootstrap";

export default defineComponent({
  name: "modal-dialog",

  props: {
    headerText: String,
    id: {
      type: String,
      required: true,
    },
    size: {
      type: String as () => "sm" | "md" | "lg" | "xl",
      default: "lg",
    },
  },
  setup(props, { expose }) {
    const modalRef = ref<Modal>(null);
    const hide = () => {
      const modal = Modal.getInstance(document.getElementById(props.id));
      modal.hide();
    };
    const show = () => {
      const modal = new Modal(document.getElementById(props.id));
      modal.show();
    };

    expose({ show, hide });

    return { modalRef };
  },
});
